const axios = require('axios');
axios.defaults.baseURL = process.env.VUE_APP_BACKEND_API_URL;
axios.defaults.withCredentials = true;

module.exports = {
    axios
}